import React from "react";
import { Link } from "~/components/Elements";
import "./Referendum2023.css";
import imgBox from "./img/referendum/box.png";
import imgMap from "./img/referendum/map.png";
const urlAllNews = "https://www.teraz.sk/referendum-2023/";
const urlAllInfo = "https://www.teraz.sk/info-referendum-2023";

const HeaderBanner = (props) => {
  return (
    <div>
      <div className="bannerBase referendum-fullWidth">
            <div className="bannerBase-inner referendum-inner">
                <img
                    src={imgBox}
                    className="bannerBase-referendum-box"
                    alt="REFERENDUM 2023"
                    width="100"
                    height="93"
                    loading="lazy"
                  ></img>

                <div className="bannerBase-referendum-title-wrapper">
                  <span>Referendum 2023</span>
                </div>

                <div className="bannerBase-referendum-cta-wrapper">
                  <Link to={urlAllNews}>
                    <div className="bannerBase-referendum-btn">Všetky správy</div>
                  </Link>

                  <Link to={urlAllInfo}>
                    <div className="bannerBase-referendum-link"><span>Viac informácií</span></div>
                  </Link>
                </div>
            </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
